module.exports = __webpack_public_path__ + "img/icon_map_3_yj_hg.02309f8f.png";